import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {MessageFormat, ButtonColor, MessageContent, DwhActionType, DWHMessageText, DWHStatus} from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Popup from '../../../Shared/Popup/PopUp';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import {connect} from 'react-redux';
import {dwhGeneralReport} from '../Reports/dwhReports';
import SimActionBtns from 'app/Components/Block/TransferOrganizationAccountBlock/Popups/SimActionBtns';

const GeneralMessage = ({messageData, buttonClick, secondButtonClick, data, selectedHetPay, userDetails, isNewLineAction}) => {
  const {icon, title, secondTitle, buttonText, redirectPath, buttonColor, format, secondButtonText, secondButtonColor} = messageData;
  const [showPopUp, setShowPopUp] = useState(false);
  useEffect(() => {
    if (format == MessageFormat.Popup) setShowPopUp(true);
    data = {...data, selectedHetPay, userDetails};
    switch (messageData) {
      case MessageContent.GeneralError:
        dwhGeneralReport({
          data,
          actionType: DwhActionType.ErrorScreen,
          messageText: DWHMessageText.GeneralError,
          status: DWHStatus.Error,
        });
        break;
      case MessageContent.SimActivatedSucceeded:
      case MessageContent.NewLineActivationSucceeded:
        dwhGeneralReport({
          data,
          actionType: DwhActionType.SuccessScreenRegularSIM,
          messageText: DWHMessageText.SuccessScreenSIM,
          status: DWHStatus.Completed,
        });
        break;
      default:
        break;
    }
  }, []);

  const handleSubmit = (buttonAction) => {
    if (buttonAction) {
      buttonAction();
    } else if (redirectPath) {
      EpiContext.navigateTo(redirectUrl());
    }
    setShowPopUp(false);
  };

  const redirectUrl = () => {
    switch (redirectPath) {
      case 'businessLobby':
        return Config.businessLobbyUrl;
      default:
        return redirectPath;
    }
  };

  function replacePlaceholders(template) {
    return template.replace(/{(\w+)}/g, (match, key) => data[key] || match);
  }

  const contentMsg = () => {
    return (
      <>
        <Image src={icon} />
        <span className='L_Title'>{replacePlaceholders(title)}</span>
        {secondTitle && <span className='M_Title'>{replacePlaceholders(secondTitle)}</span>}
        {messageData?.success && !isNewLineAction && <SimActionBtns></SimActionBtns>}
        <div className={'footerLinkAndBtn'}>
          <BtnSubmit
            className={buttonColor == ButtonColor.white ? 'white' : ''}
            text={buttonText}
            onclick={() => handleSubmit(buttonClick)}
          />
          {messageData?.success && isNewLineAction && <SimActionBtns></SimActionBtns>}
        </div>
        {secondButtonText && (
          <BtnSubmit
            className={`${secondButtonColor == ButtonColor.white ? 'white' : ''} second-button`}
            text={secondButtonText}
            onclick={() => handleSubmit(secondButtonClick)}
          />
        )}
      </>
    );
  };

  return (
    <div className='messagePage'>
      {format == MessageFormat.Popup ? (
        <Popup className='mainPopup' showPopUp={showPopUp} onClose={() => setShowPopUp(false)}>
          {contentMsg()}
        </Popup>
      ) : (
        <>{contentMsg()}</>
      )}
    </div>
  );
};

GeneralMessage.propTypes = {
  messageData: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    secondTitle: PropTypes.string,
    buttonText: PropTypes.string,
    redirectPath: PropTypes.string,
    buttonColor: PropTypes.string,
    format: PropTypes.string.isRequired,
    secondButtonText: PropTypes.string,
    secondButtonColor: PropTypes.string,
  }).isRequired,
  buttonClick: PropTypes.func,
  secondButtonClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
